<template>
	<footer class="text-center">
    <div class="col-sm-2 offset-sm-5">
    	<router-link :to="{name: 'contacto'}" class="nav-link"> Contacto </router-link>
    </div>
    <small>
      Hecho en &#127474;&#127485; con &#10084;&#65039; por el equipo de IT de Bien para Bien | {{currentYear}}
    </small>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(), // 202x
    };
  }
};
</script>